import {useMatchMedia} from '@pexip/hooks';

import {LG_DOWN} from '../../constants/mediaQueries';

export const useLgDown = () => useMatchMedia(LG_DOWN);
